<template>
  <IQOS
    :title="$t('worker_profile.attach_tables_title' + i18nSuffix)"
    required
    enabled
  >
    <div v-if="!isAnyTableAttached && !editing">
      <p class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t("worker_profile.attach_all" + i18nSuffix) }}
      </p>
    </div>
    <div v-else>
      <div v-if="!hasHallsAndTables">
        <p class="iqos-comment qrw-paragraph-md mt-16">
          {{ $t("worker_profile.attach_none" + i18nSuffix) }}
        </p>
        <BaseDivider color="v1-grey-6" class="mt-16 mb-16" />
        <div class="text-center">
          <img src="/icons/crying-panda.svg" class="panda" />
          <p class="iqos-comment qrw-paragraph-md">
            {{ $t("worker_profile.attach_no_tables") }}
          </p>
        </div>
        <router-link class="iqos-button-right" tag="div" to="/halls">
          <BaseButton color="v1-grey-10" size="md" variant="secondary" class="iqos-button-right iqos-group-item">
            {{ $t("worker_profile.attach_setup_tables") }}
          </BaseButton>
        </router-link>
      </div>
      <div v-else>
        <p class="iqos-comment qrw-paragraph-md mt-16">
          {{ $t("worker_profile.attach_certain" + i18nSuffix) }}
        </p>
        <BaseDivider color="v1-grey-6" class="mb-16 mt-16"/>
        <!-- <div class="tables-wrapper">
          <div
            class="hall-container"
            v-for="(section, index) in cafe.sections"
            :key="index"
          >
            <div
              :class="{
                'hall-title': true,
                'hall-title-attached': isHallAttached(index),
              }"
              @click="toggleHall(index)"
              v-if="editing ? true : isHallAttachedAtAll(index)"
            >
              {{ section.name }}
            </div>
            <div class="hall-tables">
              <div
                :class="{
                  'attaching-table-cell': editing
                    ? true
                    : isTableAttached(index, tindex + 1),
                }"
                v-for="(table, tindex) in section.tables_list"
                :key="tindex"
              >
                <TableCell
                  :state="'idle'"
                  :in_attachment="true"
                  @attach="toggleTableAttachment(index, tindex + 1)"
                  :is_attached="isTableAttached(index, tindex + 1)"
                  :index="tindex + 1"
                  :table="table"
                  :value="table.places_count"
                  v-if="editing ? true : isTableAttached(index, tindex + 1)"
                />
              </div>
            </div>
            <hr
              v-if="
                index < cafe.sections.length - 1 &&
                  (editing ? true : isHallAttachedAtAll(index + 1))
              "
            />
          </div>
        </div> -->
        <TableSelector 
          class="mb-16" 
          v-for="(section,sindex) in cafe.sections" 
          mode="waiter" 
          :key="sindex" 
          :section="section" 
          :section_index="sindex"
          @saved="t => $emit('saved', t)"
          :attached_tables="attached_tables"/>
      </div>
    </div>
    <!-- <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="onEditFinish"
    /> -->
  </IQOS>
</template>

<script>
import TableSelector from "@/components/halls/TableSelector.vue"
import TableCell from "@/components/halls/TableCell.vue";

export default {
  components: {
    TableSelector,
    TableCell
  },
  data() {
    return {
      editing: true,
      attached_tables: [],
    };
  },
  props: {
    waiter: Object,
  },
  methods: {
    reset() {
      this.attached_tables = (this.waiter.attached_tables || []).slice();
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    showEditUI() {
      this.editing = true;
    },
    onEditFinish() {
      this.editing = false;
      this.$emit("saved", this.attached_tables);
    },
    isTableAttached(section_index, table) {
      return !!this.attached_tables.find(
        (o) => o.section == section_index && o.table == table
      );
    },
    toggleHall(section) {
      if (!this.editing) return;

      if (this.isHallAttached(section)) {
        this.attached_tables = this.attached_tables.filter(
          (it) => it.section != section
        );
      } else {
        for (let t = 1; t <= this.cafe.sections[section].tables; t++) {
          if (!this.isTableAttached(section, t))
            this.toggleTableAttachment(section, t, true);
        }
      }

      this.$emit("saved", this.attached_tables);
    },
    isHallAttached(section) {
      for (let t = 1; t <= this.cafe.sections[section].tables; t++) {
        if (!this.isTableAttached(section, t)) {
          return false;
        }
      }

      return true;
    },

    isHallAttachedAtAll(section) {
      for (let t = 1; t <= this.cafe.sections[section].tables; t++) {
        if (this.isTableAttached(section, t)) {
          return true;
        }
      }

      return false;
    },
    toggleTableAttachment(section_index, table, dont_save) {
      if (!this.editing) return;

      const index = this.attached_tables.findIndex(
        (o) => o.section == section_index && o.table == table
      );

      if (index !== -1) {
        this.attached_tables.splice(index, 1);
      } else {
        this.attached_tables.push({
          section: section_index,
          table,
        });
      }

      if (!dont_save) this.$emit("saved", this.attached_tables);
    },
  },
  computed: {
    isAnyTableAttached() {
      return !!this.attached_tables.length;
    },
    hasHallsAndTables() {
      return this.cafe.sections && this.cafe.sections.length;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
    i18nSuffix() {
      return this.isHotel ? "_hotel" : "";
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style>
.panda {
  width: 36vh;
  height: auto;
  max-width: 36vh;
}

.hall-title {
  width: 100%;
  background: #464646;
  padding: 0.5vh 0;
  color: #ededed;
  cursor: pointer;
  text-align: center;
  border-radius: 0.6vh;
  font-size: 2vh;
}

.hall-title-attached {
  color: #ededed;
  background: #129b81;
}

.hall-tables {
  justify-content: flex-start;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  position: relative;
  /* margin-bottom: 1.65vh; */
}

.attaching-table-cell:last-child {
  margin-right: 0;
}

.attaching-table-cell {
  margin-top: 1.6666vh;
  margin-right: 1.7777vh;
  text-align: center;
  width: calc(20% - 1.5vh);
  max-width: calc(20% - 1.5vh);
  min-width: calc(20% - 1.5vh);
}

.attaching-table-cell:nth-child(5n) {
  margin-right: 0 !important;
}
</style>
